import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useUpdateCryptocurrencyMutation } from "../../redux/cryptocurrencyApi";

import { useTranslation } from "react-i18next";

function EditCryptocurrency({ show, onHide, cryptocurrency, users }) {
    const { t } = useTranslation();
    const [editData, setEditData] = useState({});
    const [updateCryptocurrency] = useUpdateCryptocurrencyMutation();

    useEffect(() => {
        if (cryptocurrency) {
            setEditData(cryptocurrency);
        }
    }, [cryptocurrency]);

    const handleEditSave = async () => {
        const formData = new FormData();
        for (const key in editData) {
            if (key === 'logo_url' || key === 'logo') continue;
            if (editData[key] !== null && editData[key] !== undefined) {
                formData.append(key, editData[key]);
            }
        }

        if (editData.logo instanceof File) {
            formData.append("logo", editData.logo);
        }

        await updateCryptocurrency(formData);
        onHide();
    };

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>{t('edit_cryptocurrency')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label>{t('logo')}</Form.Label>
                        {editData.logo_url && (
                            <div className="mb-2">
                                <img src={editData.logo_url} alt="Current Logo" style={{ width: '50px', height: '50px', objectFit: 'contain' }} />
                            </div>
                        )}
                        <Form.Control
                            type="file"
                            onChange={(e) => setEditData({ ...editData, logo: e.target.files[0] })}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>{t('status') || "Status"}</Form.Label>
                        <Form.Select
                            value={editData.crypto_status || "active"}
                            onChange={(e) => setEditData({ ...editData, crypto_status: e.target.value })}
                        >
                            <option value="active">{t('active') || "Active"}</option>
                            <option value="inactive">{t('inactive') || "Inactive"}</option>
                        </Form.Select>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>{t('etoken_min_withdrawal_amount')}</Form.Label>
                        <Form.Control
                            type="number"
                            value={editData.etoken_min_withdrawal_amount || ""}
                            onChange={(e) => setEditData({ ...editData, etoken_min_withdrawal_amount: e.target.value })}
                        />
                    </Form.Group>
                    {(editData.coin_symbol === "USDT" || editData.coin_symbol === "USDC" || editData.symbol === "USDT" || editData.symbol === "USDC") && (
                        <Form.Group className="mb-3">
                            <Form.Label>{t('allow_for_swap_staking') || "Allow For Swap Staking"}</Form.Label>
                            <Form.Select
                                value={editData.allow_for_swap_staking || "no"}
                                onChange={(e) => setEditData({ ...editData, allow_for_swap_staking: e.target.value })}
                            >
                                <option value="yes">{t('yes')}</option>
                                <option value="no">{t('no')}</option>
                            </Form.Select>
                        </Form.Group>
                    )}
                    <Form.Group className="mb-3">
                        <Form.Label>{t('is_swapable')}</Form.Label>
                        <Form.Select
                            value={editData.is_swapable || ""}
                            onChange={(e) => setEditData({ ...editData, is_swapable: e.target.value })}
                        >
                            <option value="yes">{t('yes')}</option>
                            <option value="no">{t('no')}</option>
                        </Form.Select>
                    </Form.Group>
                    {editData.is_swapable === "yes" && (
                        <>
                            <Form.Group className="mb-3">
                                <Form.Label>{t('swap_fee_cryptocurrency')}</Form.Label>
                                <Form.Select
                                    value={editData.swap_fee_cryptocurrency_id || ""}
                                    onChange={(e) => setEditData({ ...editData, swap_fee_cryptocurrency_id: e.target.value })}
                                >
                                    <option value="">{t('select_cryptocurrency')}</option>
                                    {users.map((crypto, index) => (
                                        <option key={index} value={crypto.id}>
                                            {crypto.coin_name} ({crypto.coin_symbol})- ({crypto.symbol})
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>{t('swap_fee_type')}</Form.Label>
                                <Form.Select
                                    value={editData.swap_fee_type || ""}
                                    onChange={(e) => setEditData({ ...editData, swap_fee_type: e.target.value })}
                                >
                                    <option value="fixed">{t('fixed')}</option>
                                    <option value="percentage">{t('percentage')}</option>
                                </Form.Select>
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>{t('swap_fee_amount')}</Form.Label>
                                <Form.Control
                                    type="number"
                                    value={editData.swap_fee_amount || ""}
                                    onChange={(e) => setEditData({ ...editData, swap_fee_amount: e.target.value })}
                                />
                            </Form.Group>
                        </>
                    )}

                    <Form.Group className="mb-3">
                        <Form.Label>{t('transfer_fee_status')}</Form.Label>
                        <Form.Select
                            value={editData.transfer_fee_status || ""}
                            onChange={(e) => setEditData({ ...editData, transfer_fee_status: e.target.value })}
                        >
                            <option value="">{t('select')}</option>
                            <option value="ON">ON</option>
                            <option value="OFF">OFF</option>
                        </Form.Select>
                    </Form.Group>
                    {editData.transfer_fee_status === "ON" && (
                        <>
                            <Form.Group className="mb-3">
                                <Form.Label>{t('transfer_fee_cryptocurrency')}</Form.Label>
                                <Form.Select
                                    value={editData.transfer_fee_cryptocurrency_id || ""}
                                    onChange={(e) => setEditData({ ...editData, transfer_fee_cryptocurrency_id: e.target.value })}
                                >
                                    <option value="">{t('select_cryptocurrency')}</option>
                                    {users.map((crypto, index) => (
                                        <option key={index} value={crypto.id}>
                                            {crypto.coin_name} ({crypto.coin_symbol})- ({crypto.symbol})
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>{t('transfer_fee_type')}</Form.Label>
                                <Form.Select
                                    value={editData.transfer_fee_type || ""}
                                    onChange={(e) => setEditData({ ...editData, transfer_fee_type: e.target.value })}
                                >
                                    <option value="fixed">{t('fixed')}</option>
                                    <option value="percentage">{t('percentage')}</option>
                                </Form.Select>
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>{t('transfer_fee_amount')}</Form.Label>
                                <Form.Control
                                    type="number"
                                    value={editData.transfer_fee_amount || ""}
                                    onChange={(e) => setEditData({ ...editData, transfer_fee_amount: e.target.value })}
                                />
                            </Form.Group>
                        </>
                    )}
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    {t('close')}
                </Button>
                <Button variant="primary" onClick={handleEditSave}>
                    {t('save_changes')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default EditCryptocurrency;
